import React from "react";
import styled from "styled-components";
import type { WhatsAppMessageItem } from "../../../../Data/whatsapp.dto";

interface MessageBubbleProps {
  message: WhatsAppMessageItem;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isOutbound = message.direction === "outbound";

  return (
    <Bubble $outbound={isOutbound}>
      <BubbleText>{message.text}</BubbleText>
      <BubbleMeta $outbound={isOutbound}>
        {new Date(message.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
      </BubbleMeta>
    </Bubble>
  );
};

export default MessageBubble;

const Bubble = styled.div<{ $outbound: boolean }>`
  max-width: 75%;
  min-width: 80px;
  align-self: ${(p) => (p.$outbound ? "flex-end" : "flex-start")};
  padding: 10px 14px;
  border-radius: 16px;
  border-bottom-right-radius: ${(p) => (p.$outbound ? "4px" : "16px")};
  border-bottom-left-radius: ${(p) => (p.$outbound ? "16px" : "4px")};
  background: ${(p) =>
    p.$outbound
      ? "linear-gradient(135deg, #fff6e8 0%, #fceef7 100%)"
      : "#ffffff"};
  color: #171717;
  border: 1px solid
    ${(p) => (p.$outbound ? "rgba(201, 77, 170, 0.12)" : "rgba(23, 23, 23, 0.06)")};
  box-shadow: ${(p) =>
    p.$outbound
      ? "0 1px 3px rgba(201, 77, 170, 0.08)"
      : "0 1px 2px rgba(0, 0, 0, 0.05)"};
`;

const BubbleText = styled.div`
  font-family: "Urbanist", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.45;
  color: #171717;
  white-space: pre-wrap;
  word-break: break-word;
`;

const BubbleMeta = styled.div<{ $outbound: boolean }>`
  font-family: "Montserrat", sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: ${(p) => (p.$outbound ? "rgba(201, 77, 170, 0.65)" : "rgba(23, 23, 23, 0.45)")};
  margin-top: 6px;
  display: flex;
  align-items: center;
  justify-content: ${(p) => (p.$outbound ? "flex-end" : "flex-start")};
  gap: 6px;
`;

const CategoryBadge = styled.span<{ $outbound: boolean }>`
  font-size: 10px;
  font-weight: 600;
  text-transform: capitalize;
  padding: 1px 6px;
  border-radius: 4px;
  background: ${(p) => (p.$outbound ? "rgba(201, 77, 170, 0.1)" : "rgba(0, 0, 0, 0.06)")};
  color: ${(p) => (p.$outbound ? "#c94daa" : "rgba(23, 23, 23, 0.55)")};
`;
